import {
  extractTypeInProtoFormat,
  isLegacyType,
  LegacyComplexType,
  LegacySingleType,
  LegacyType,
  Type,
  TypeParameter,
} from './typeParser';
import { getReferencesToMessagesInType } from '../../../utils/typeUtils';

export const PRIMITIVES = {
  string: true,
  integer: true,
  boolean: true,
  float: true,
  number: true,
  array: true,
  void: true,
  object: true,
  null: true,
};

export const lowerCase = (str) => str.toLowerCase();

export const isArrayType = (type): boolean =>
  !!type.name && type.name.toLowerCase() === 'array';

export const isPromiseType = (type): boolean =>
  !!type.name && type.name.toLowerCase() === 'promise';

export const hasMultipleTypes = (type): boolean =>
  Array.isArray(type) && type.length > 1;

export const extractType = (
  type: Type | LegacyType | TypeParameter = '',
): LegacySingleType | ReturnType<typeof extractTypeInProtoFormat> => {
  if (isLegacyType(type)) {
    if (hasMultipleTypes(type)) {
      // if the type is an array, return the first one
      return type[0];
    }
    if (typeof type === 'string') {
      // if the type is a primitive type or a reference type, return it
      return type;
    }
    // if the type is neither an array nor a string, it's a complex type
    const legacyComplexType = type as LegacyComplexType;
    return legacyComplexType.name
      ? legacyComplexType.typeParams[0]
      : legacyComplexType;
  }

  // If the type is not in legacy format, it is in the new format defined in proto.
  const typeAsProtoSchema = type as Type | TypeParameter;
  return extractTypeInProtoFormat(typeAsProtoSchema);
};

export const areAllTypesTheSame = (
  types: Type[] | LegacySingleType[],
  store,
): boolean => {
  const possibleReferenceTypes = getReferencesToMessagesInType(types, store);

  if (possibleReferenceTypes.length === 0) {
    return true;
  }

  const firstType = extractType(possibleReferenceTypes[0]);
  return possibleReferenceTypes.every(
    (type) => extractType(type) === firstType,
  );
};
